import slider3 from '../../images/customer.png'
import slider2 from '../../images/floorplan.png'
import slider1 from '../../images/slider-ss1.webp'

export const items = [
  {
    image: slider1,
    alt: 'Slider 1',
    contentKey: 'authLayout.smarterCrowds',
    maxWidth: '20rem',
  },
  {
    image: slider2,
    alt: 'Slider 2',
    contentKey: 'authLayout.effortlessFloorPlan',
    maxWidth: '32rem',
  },
  {
    image: slider3,
    alt: 'Slider 3',
    contentKey: 'authLayout.simplifyingBookings',
    maxWidth: '24rem',
  },
]
